var map = {
	"./007-microphone-1.png": 303,
	"./010-home.png": 300,
	"./013-document-1.png": 302,
	"./014-document.png": 298,
	"./015-color-palette.png": 299,
	"./017-video-camera.png": 301,
	"./image.png": 341,
	"./label.png": 338,
	"./left.svg": 357,
	"./right.svg": 340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 419;